import { HomeModernIcon, ChartBarIcon, SparklesIcon, HeartIcon, PuzzlePieceIcon, DevicePhoneMobileIcon, ShieldCheckIcon, ChatBubbleLeftRightIcon, UsersIcon } from '@heroicons/react/24/outline';

const SystemModulesSection = () => {
  const modules = [
    {
      icon: HomeModernIcon,
      title: 'Home Safety Checks',
      description: 'Take a photo of any room and get personalized recommendations to reduce fall risks, from rugs and lighting to grab bars and clutter.'
    },
    {
      icon: HeartIcon,
      title: 'Wellness & Vitals Tracking',
      description: 'Track blood pressure, weight, sleep, mood, and symptoms in one place. Connect your Oura, Fitbit, or Withings for automatic updates.'
    },
    {
      icon: ShieldCheckIcon,
      title: 'Is This a Scam?',
      description: 'Paste a suspicious text, email, or call script and get an instant verdict, red flags explained, next steps included. Free for everyone.'
    },
    {
      icon: SparklesIcon,
      title: 'Personal AI Companions',
      description: 'Meet Avery, Clarity, Riley, Luigi, Finn, and Charlie, friendly guides for health, safety, cooking, and more. Free on every plan, with 5 chats per week.'
    },
    {
      icon: DevicePhoneMobileIcon,
      title: 'Doctor Visit Notes',
      description: 'Capture what the doctor said and what you need to do next, your personal notebook so nothing gets forgotten after the appointment.'
    },
    {
      icon: ChartBarIcon,
      title: 'Your ThriveScore',
      description: 'One simple number that reflects your overall wellness and home safety progress. Watch it grow as you build healthy daily habits.'
    },
    {
      icon: PuzzlePieceIcon,
      title: 'Brain Games & Fitness Videos',
      description: 'Stay sharp with fun daily brain games and follow along with gentle exercise videos, all designed for real life at home.'
    },
    {
      icon: ChatBubbleLeftRightIcon,
      title: 'Family Conversation Guides',
      description: 'Scripts and prompts for the conversations nobody teaches you how to have, about safety, driving, finances, and future planning.'
    },
    {
      icon: UsersIcon,
      title: 'ThriveCircle',
      description: 'One private space where the older adult, family members, and caregivers stay connected, share updates, and coordinate care without the chaos of group texts and phone tag.'
    }
  ];

  return (
    <section className="py-24 md:py-32 bg-gradient-to-br from-background via-accent/10 to-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Everything You Need to Thrive at Home
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Safety, wellness, and connection, all in one place, designed for real life.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {modules.map((module, index) => (
            <div
              key={index}
              className="bg-card rounded-md p-8 shadow-raised hover:shadow-floating hover:-translate-y-0.5 transition-all duration-300 group"
            >
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:transition-colors">
                  <module.icon className="w-7 h-7 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-foreground mb-2">
                    {module.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {module.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SystemModulesSection;
